import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { NotificationManagement } from '../modal';

export default function reducer(state: NotificationManagement = new NotificationManagement(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.NOTIFICATION_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.NOTIFICATION_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.NOTIFICATION_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
